import styled from '@emotion/styled';

export const BlackInformationChip = styled.div`
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    border-radius: 70px;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
`;

export const InformationChipWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    border-radius: 70px;
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;
`;
